import React, { useState } from "react";
import { Box } from "@mui/material";
import Typography from "@mui/material/Typography";
import styles from "../inputFields/styles.js";
import "./styles/TagContainer.css";
import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material/styles";

const StyledToggleButtonGroup = (props) => (
  <ToggleButtonGroup
    {...props}
    sx={{
      width: '100%',
      '& .MuiToggleButtonGroup-grouped': {
        margin: 0,
        border: 0,
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
        width: '100%',
      },
      ...props.sx,
    }}
  />
);

const StyledToggleButton = (props) => (
  <ToggleButton
    {...props}
    sx={{
      padding: 0,
      textTransform: 'none',
      display: 'block',
      width: '100%',
      '&:focus .label-wrapper-no-color, &:focus-visible .label-wrapper-no-color': {
        cursor: 'pointer',
        border: '2px solid #ff9800 !important',
        filter: 'brightness(95%)',
        transform: 'scale(1.05)',
        position: 'relative',
      },
      ...props.sx,
    }}
  />
);

const theme = createTheme({
  palette: {
    action: {
      active: "#221d26",
    },
    text: {
      primary: "#221d26",
    },
  },
});

const InactiveTagContainer = (props) => {
  const [checked, setChecked] = useState(props.info.checked);

  const handleCheck = () => {
    const newChecked = !checked;
    setChecked(newChecked);
    props.onCheckedChange(props.info.quoteTagID, newChecked);

    if (newChecked) {
      props.restrictions.forEach((item) => {
        if (
          item.type !== "dropdown" &&
          item.type !== "datetime" &&
          item.type !== "date" &&
          item.type !== "time" &&
          item.type !== "checkbox"
        )
          if (item.required) props.onAlert.addAlert(item.prompt);
      });
    } else {
      props.restrictions.forEach((item) => {
        if (
          item.type !== "dropdown" &&
          item.type !== "datetime" &&
          item.type !== "date" &&
          item.type !== "time" &&
          item.type !== "checkbox"
        )
          if (item.required) props.onAlert.removeAlert(item.prompt);
      });
    }
  };

  // Determine colors using the same logic as TagContainer
  const dbTagColor = props.info?.tagColor;
  const dbTagTextColor = props.info?.tagTextColor;

  const defaultInactiveBorderColor = '#9e9e9e'; // Original default for un-checked
  const defaultCheckedBorderColorFromCSS = '#337AB7'; // From .tag-checked in CSS
  
  let currentBorderColor;
  if (dbTagColor) {
    currentBorderColor = dbTagColor;
  } else {
    currentBorderColor = checked ? defaultCheckedBorderColorFromCSS : defaultInactiveBorderColor;
  }

  // For inactive tags, use the database color but with reduced opacity in the background
  // For checked tags, use full database color
  const currentBackgroundColor = dbTagColor 
    ? (checked ? dbTagColor : dbTagColor) // Use DB color for both checked and unchecked
    : (checked ? 'white' : '#f0f0f0'); // Default colors when no DB color

  const currentTextColor = dbTagTextColor || '#000000';

  return (
    <ThemeProvider theme={theme}>
      <div className="tag-container">
        <StyledToggleButtonGroup
          size="small"
          value={checked ? "selected" : "not-selected"}
          exclusive
          onChange={handleCheck}
        >
          <StyledToggleButton value="selected" disableRipple>
            <Box
              className={`label-wrapper-no-color ${checked ? "tag-checked" : ""}`}
              style={{
                ...styles.labelWrapperNoColor,
                '--tag-border-color': currentBorderColor,
                '--tag-bg-color': currentBackgroundColor,
                '--tag-text-color': currentTextColor,
                opacity: checked ? 1 : 0.7,
                width: '100%',
                height: '100%',
                boxSizing: 'border-box'
              }}
            >
              {props.info.icon_url && (
                <img
                  src={props.info.icon_url}
                  alt={props.label}
                  className="tag-icon"
                />
              )}
              <Typography
                variant="subtitle1"
                className="label-no-color"
                style={{
                  ...styles.labelNoColor,
                  color: currentTextColor,
                }}
              >
                {props.label}
              </Typography>
            </Box>
          </StyledToggleButton>
        </StyledToggleButtonGroup>
      </div>
    </ThemeProvider>
  );
};

export default InactiveTagContainer;